var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberDashboardViewCandidate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20248 6.79794C1.15386 6.92891 1.15386 7.07297 1.20248 7.20394C1.67597 8.35203 2.47969 9.33367 3.51176 10.0244C4.54383 10.7152 5.75775 11.0839 6.99964 11.0839C8.24153 11.0839 9.45546 10.7152 10.4875 10.0244C11.5196 9.33367 12.3233 8.35203 12.7968 7.20394C12.8454 7.07297 12.8454 6.92891 12.7968 6.79794C12.3233 5.64986 11.5196 4.66822 10.4875 3.97747C9.45546 3.28672 8.24153 2.91797 6.99964 2.91797C5.75775 2.91797 4.54383 3.28672 3.51176 3.97747C2.47969 4.66822 1.67597 5.64986 1.20248 6.79794Z",
    stroke: "#626975",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z",
    stroke: "#626975",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberDashboardViewCandidate);
export default __webpack_public_path__ + "static/media/member-dashboard-view-candidate.f945eb6c8d1226ebaae0a51d7a751dcb.svg";
export { ForwardRef as ReactComponent };